<template>
  <div id="app">
    <router-view class="page-view" />
    <van-tabbar v-if="showTabbar" v-model="activeTab" :fixed="true" :safe-area-inset-bottom="true" active-color="rgb(242,124,52)" inactive-color="#969799" @change="onTabChange">
      <van-tabbar-item icon="friends-o" name="customer-track">学员管理</van-tabbar-item>
      <van-tabbar-item icon="clock-o" name="course-consumed">课消管理</van-tabbar-item>
      <van-tabbar-item icon="balance-list-o" name="income-manage">收入管理</van-tabbar-item>
      <van-tabbar-item icon="records" name="material-approval">教材管理</van-tabbar-item>
      <van-tabbar-item icon="balance-o" name="expense-approval">报销管理</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      activeTab: "customer-track"
    }
  },
  computed: {
    showTabbar() {
      return true
    }
  },
  watch: {
    $route(to) {
      const nameMap = {
        CustomerTrack: "customer-track",
        CourseConsumed: "course-consumed",
        MaterialApproval: "material-approval",
        ExpenseApproval: "expense-approval",
        IncomeManage: "income-manage"
      }
      const tab = nameMap[to.name]
      if (tab && tab !== this.activeTab) {
        this.activeTab = tab
      }
    }
  },
  methods: {
    onTabChange(name) {
      const routeMap = {
        "customer-track": "/customer-track",
        "course-consumed": "/course-consumed",
        "material-approval": "/material-approval",
        "expense-approval": "/expense-approval",
        "income-manage": "/income-manage"
      }
      const path = routeMap[name]
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style>
:root {
  --app-tabbar-height: 50px;
  --app-safe-area-bottom: constant(safe-area-inset-bottom);
  --app-safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --app-tabbar-offset: calc(var(--app-tabbar-height) + var(--app-safe-area-bottom));
}

#app {
  min-height: 100vh;
}

.page-view {
  padding-bottom: var(--app-tabbar-offset);
}
</style>
